import { BlockStack, Card, Layout } from '@shopify/polaris'
import type { ReactElement } from 'react'
import BoldText from '../BoldText'
import RegularText from '../RegularText'

interface ILayoutSettingsProps {
  title: string
  helpText: string
  children: ReactElement
}

const LayoutSettings = ({ title, helpText, children }: ILayoutSettingsProps) => {
  return (
    <>
    <Layout>
      <Layout.Section variant="oneThird">
        <BlockStack gap={'200'}>
          <BoldText>
            {title}
          </BoldText>
          <RegularText>
            {helpText}
          </RegularText>
        </BlockStack>
      </Layout.Section>
      <Layout.Section>
        <Card>{children}</Card>
      </Layout.Section>
    </Layout>
    </>
  )
}

export default LayoutSettings
